import logo from './logo.png';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          experience the mood you desire
        </p>
        <a
          className="App-link"
          href="https://play.google.com/store/apps/details?id=com.duttakapil.moody"
          target="_blank"
          rel="noopener noreferrer"
        >
          Get Moody App
        </a>
      </header>
    </div>
  );
}

export default App;
